export default __webpack_public_path__ + "static/media/novan.0dc4657e.jpg";